import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=69476a92&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69476a92')) {
      api.createRecord('69476a92', component.options)
    } else {
      api.reload('69476a92', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=69476a92&", function () {
      api.rerender('69476a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/comp/childrenage.vue"
export default component.exports